// extracted by mini-css-extract-plugin
export default {"White":"#FFFFFF","BreakpointFromLarge":"(min-width: 960px)","textWrapper":"Openings_textWrapper__B6ue6","wrapper":"Openings_wrapper__UwgfJ"};